import { StateInterface } from "./state";
import { GlobalInterface } from "../index.js";
import { GetterTree } from "vuex";

const getters: GetterTree<StateInterface, GlobalInterface> = {
  allToPlaylistAssignedDeviceIDs: (state) => (playlistID: number) => {
    const foundPlaylist = state.allUserPlaylists.find(
      (pl) => pl.ID === playlistID
    );

    if (foundPlaylist) {
      return foundPlaylist.deviceIds;
    } else {
      return [];
    }
  },
  allUserPlaylists: (state) => state.allUserPlaylists,
  getDeviceAssignedPlaylistsByID: (state) => (DID: number) => {
    return state.allUserPlaylists.filter((dev) => dev.deviceIds.includes(DID));
  },
  getDeviceAssignedPlaylistByIDs: (state) => (DID: number) => {
    let userPlaylists = state.allUserPlaylists.filter((pl) =>
      pl.deviceIds.includes(DID)
    );

    var playlistIDs: number[] = [];
    userPlaylists.forEach((pl) => {
      playlistIDs.push(pl.ID);
    });

    return playlistIDs;
  },
  playlistNameAlreadyTaken: (state) => (playlistName: string) => {
    const pl = state.allUserPlaylists.find((pl) => pl.NAME === playlistName);
    return !!pl;
  },

  getGroupPlaylists: (state) => (groupId: number) => {
	  const groupPlaylists = state.allUserPlaylists.filter((playlist) => { 
		return playlist.groupIds.includes(groupId);
	});
    return groupPlaylists;
  },
};

export default getters;
